(function(){
  // Live cart count update after add-to-cart from product cards
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.classList.contains('pcard__form')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', {method:'POST', body:data, headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(){ return fetch('/cart.js'); })
      .then(function(r){return r.json();})
      .then(function(cart){
        var el = document.querySelector('[data-cart-count]');
        if(el) el.textContent = cart.item_count;
        var btn = form.querySelector('button');
        if(btn){ var t=btn.textContent; btn.textContent='Added ✓'; setTimeout(function(){btn.textContent=t;},1200); }
      })
      .catch(function(){ form.submit(); });
  });
})();
